interface IFileIconProps {
    voucherHolderId: number,
    fileName: string,
    value: string,
    docType: number,
    inProcess: boolean,
    onDownload: (voucherHolderId: number, docType: number) => void
}

const FileIcon = (props: IFileIconProps) => {
    let { voucherHolderId, fileName, value, docType, inProcess, onDownload } = props;

    if (value != '') {
        return (
            <div style={{ marginRight: 5 }} onClick={(e) => onDownload(voucherHolderId, docType)}><span className='badge badge-success' title={`${fileName} Uploaded`}><span className='glyphicon glyphicon-ok'></span></span></div>
        );
    }

    if (inProcess) {
        return (
            <div style={{ marginRight: 5 }}><span className='badge badge-warning' title={`${fileName} Requested`}><span className='glyphicon glyphicon-time'></span></span></div>
        );
    }

    return (
        <div style={{ marginRight: 5 }}><span className='badge badge-danger' title={`${fileName} NOT Uploaded`}><span className='glyphicon glyphicon-remove'></span></span></div>
    );
}

export default FileIcon;